export const CALENDAR_WEEK_STARTS_ON = 0;
